import CustomButton from "../custom-button";
import CustomModal from "../custom-modal";

const ClearStorageConfirmationModal = ({ onAccepted, ...otherProps }) => {
  return (
    <CustomModal
      id="clear-storage-confirmation-modal"
      headerTitle="Confirmar acción"
      {...otherProps}
    >
      <div className="modal-body">
        <div className="">
          ¡Atención, esto no se puede deshacer! Todos los datos del almacenamiento local serán
          eliminados.
        </div>
        <div className="float-right">
          <CustomButton onClick={onAccepted} text="Confirmar" color="red" />
          <CustomButton onClick={otherProps.onCloseModal} text="Cancelar" />
        </div>
      </div>
    </CustomModal>
  );
};

export default ClearStorageConfirmationModal;
